import { CategorizationChangeEvent } from "../events/categorization-change-event";
import { DataSourceQuery } from "../datasource/data-source-query";
import { MonitorSlaSelectEvent } from "../events/monitor-sla-select-event";
import { MonitorSlaChangeEvent } from "../events/monitor-sla-change-event";

/**
 * This class is used to map an event comming out of the SLA monitor into a Query
 * that can be passed into e5core-search-results component.
 */
export class CreateSlaQuery {

    public static fromMonitorSlaChangeEvent(event:MonitorSlaChangeEvent):DataSourceQuery {
        let query = new DataSourceQuery() ;
        query.Expressions = [
            { Field: "Category1_Id", Value: event.category1Id.toString() },
            { Field: "Category2_Id", Value: event.category2Id.toString() },
            { Field: "Category3_Id", Value: event.category3Id.toString() },
            { Field: "CategoryActivity_Id", Value: "0"},
            { Field: "Statuses", Value:"1,2,3" },
            { Field: "SLAType",  Value:"0" },
            { Field: "IsHours", Value: "true" },
            { Field: "ApproachingIncrement", Value:"24" }
        ] ;
        return (query) ;
    }

    public static fromMonitorSlaSelectEvent(event:MonitorSlaSelectEvent):DataSourceQuery {
        let query = new DataSourceQuery() ;
        let slaType = "0" ;
        if(event.slaGroup) {
            let group = event.slaGroup.toLocaleLowerCase() ;
            let map = { insla : "1", approaching: "2", expired: "3" } ;
            slaType = map[group] || "0" ;
        }

        query.Expressions = [
            { Field: "Category1_Id", Value: event.category1Id.toString() },
            { Field: "Category2_Id", Value: event.category2Id.toString() },
            { Field: "Category3_Id", Value: event.category3Id.toString() },
            { Field: "CategoryActivity_Id", Value: event.activityId.toString() },
            { Field: "Statuses", Value:"1,2,3" },
            { Field: "SLAType",  Value: slaType },
            { Field: "IsHours", Value: "true" },
            { Field: "ApproachingIncrement", Value: "24" }
        ] ;
        return (query) ;
    }

}